import { createServerFn } from "@tanstack/react-start";

import {
    ListingDetailInputSchema,
    type ListingDetailInput,
} from "./listing-detail.contract.ts";
import {
    getDraftListingPreviewData,
    getListingDetailData,
} from "./listing-detail.server.ts";

export const getListingDetail = createServerFn({ method: "GET" })
    .inputValidator((input: ListingDetailInput) =>
        ListingDetailInputSchema.parse(input),
    )
    .handler(async ({ data }) => getListingDetailData(data.listingId));

export const getDraftListingPreview = createServerFn({ method: "GET" })
    .inputValidator((input: ListingDetailInput) =>
        ListingDetailInputSchema.parse(input),
    )
    .handler(async ({ data }) => {
        const { setResponseHeaders } =
            await import("@tanstack/react-start/server");
        setResponseHeaders(
            new Headers({
                "Cache-Control": "private, no-store",
                "X-Robots-Tag": "noindex, nofollow",
            }),
        );
        return getDraftListingPreviewData(data.listingId);
    });
